export enum WidgetLinkingGroupId {
    NONE    = 0,
    RED     = 1,
    ORANGE  = 2,
    YELLOW  = 3,
    GREEN   = 4,
    BLUE    = 5,
    MAGENTA = 6,
    ALL     = 7
}
